import axios from "@axios";

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchCustomFields(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/custom-fields", { params: queryParams })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },
        fetchCustomFieldGroups(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get("list/custom-field-groups", { params: queryParams })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },
        fetchCustomField(ctx, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/custom-fields/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        addCustomField(ctx, userData) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/custom-fields", userData)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            if (
                                typeof error.response.data.errors !==
                                "undefined"
                            ) {
                                const keys = Object.keys(
                                    error.response.data.errors
                                );
                                const values = Object.values(
                                    error.response.data.errors
                                );
                                for (let i = 0; i <= keys.length; i += 1) {
                                    if (
                                        error.response.data.errors.hasOwnProperty.call(
                                            values,
                                            i
                                        )
                                    ) {
                                        reject(values[0][0]);
                                    }
                                }
                            }
                        } else {
                            reject(error);
                        }
                    });
            });
        },
        updateCustomField(ctx, customFields) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/custom-fields/${customFields.id}`, customFields.data)
                    .then(response => {
                        resolve(response);
                        
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            if (
                                typeof error.response.data.errors !==
                                "undefined"
                            ) {
                                const keys = Object.keys(
                                    error.response.data.errors
                                );
                                const values = Object.values(
                                    error.response.data.errors
                                );
                                for (let i = 0; i <= keys.length; i += 1) {
                                    if (
                                        error.response.data.errors.hasOwnProperty.call(
                                            values,
                                            i
                                        )
                                    ) {
                                        reject(values[0][0]);
                                    }
                                }
                            }
                        } else {
                            reject(error);
                        }
                    });
            });
        },
        removeCustomfield(ctx, userId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/custom-fields/${userId}`)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        removeMultipleCustomFields(ctx, ids) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/deleteMultipleCustomFields/`, { ids: ids })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
    }
};
